import { Link } from "react-router-dom";
import "../Css/Admin.css";
import Presentation from "./presentation";
import ListTools from "./ListTools";


export default function Admin() {

  return (
    <>
      <div id='Admin' className='admin-container'>
        <Presentation></Presentation>
      </div>
      <ListTools></ListTools>
    </>
   
    
  );
}